import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Expectations from './components/Expectations';
import EditorialBlocks from './components/EditorialBlocks';
import BookingForm from './components/BookingForm';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-vintage-white selection:bg-olive-grove selection:text-vintage-white">
      <Navbar />
      <main>
        <Hero />
        <Expectations />
        <EditorialBlocks />
        <BookingForm />
      </main>
      <Footer />
    </div>
  );
}

export default App;